import React from 'react';
import eraPage from '../assets/era-page.png';
import sdAppsPage from '../assets/sd-app-page.png';
import sdPage from '../assets/sd-page.png';
import edgentaPage from '../assets/edgenta-page.png';
import cipPage from '../assets/cip-page.png';
import astroPage from '../assets/astro-page.png';
import netflixPage from '../assets/netflix-page.png';
import weddingPage from '../assets/wedding-page.png';

const projects = [
    {
        title: 'ServeDeck Apps',
        pos: 'Mobile Developer (React Native, Spring)',
        link: 'https://apps.apple.com/my/app/servedeck/id1387798423',
        img: sdAppsPage
    },
    {
        title: 'ServeDeck',
        pos: 'Website Developer (Angular, Spring)',
        link: 'https://www.servedeck.com/',
        img: sdPage
    },
    {
        title: 'EdgentaNXT',
        pos: 'Website Developer (Angular, Strapi)',
        link: 'https://www.edgentanxt.com/',
        img: edgentaPage
    },
    {
        title: 'CIP - PLUS',
        pos: 'Frontend Developer (Angular)',
        link: 'https://cip.plus.com.my/#/',
        img: cipPage
    },
    {
        title: 'Astro Clone',
        pos: 'Frontend Developer (React.js)',
        link: 'https://astrohilmanreactjs.web.app/',
        img: astroPage
    },
    {
        title: 'Netflix Clone',
        pos: 'Frontend Developer (React.js)',
        link: 'https://netflix-hilman.web.app/',
        img: netflixPage
    },
    {
        title: 'personal Wedding Site',
        pos: 'Website Designer (Wix)',
        link: 'https://hilmanxshifa.wixsite.com/wedding',
        img: weddingPage
    },
    {
        title: 'ERA',
        pos: 'Frontend Developer (Angular)',
        link: 'https://era.tm.com.my/welcome',
        img: eraPage
    }
]

const Project = () => {
    return (
        <div id="project">
            <div className="max-project">
                <h2><i>Projects</i></h2>
                <div className='row'>
                    {projects.map((proj, id) => (
                        <div className='col-md-4' key={id}>
                            <img style={{width: '250px', height: '250px'}} src={proj.img} alt='' onClick={() => window.open(proj.link)}/>
                            <p className='p2'>{proj.title}</p>
                            <p className='p3'>{proj.pos}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Project
